@if(showHeader()) {
<div id="lp-header" class="lp-header" [class.fixed]="fixHeader()">
  <emi-header />
</div>
}

<div class="emi-container" [style.overflow]="hideNav() ? null : 'hidden'">
  @if(!hideNav()) {
  <emi-side-nav />
  }

  <div class="flex flex-col flex-1 w-full">
    <div
      id="emiContent"
      class="emi-content"
      [style.overflow]="hideNav() ? null : 'auto'"
      [style.padding]="hideNav() ? '0' : null"
    >
      <router-outlet />
    </div>
    @if(!hideNav() && userStore.isExternalUser()) {
    <emi-footer />
    }
  </div>
</div>
<p-toast />
<emi-status-modal />
<emi-spinner />
@if(isBrowser) {
<emi-cookie-consent />
}
<emi-contact-us />
